<template>
  <div :class="statusClass">
    <!-- <div class="waiter-flag" v-if="shouldShowWaiter">{{ order.waiter }}</div> -->

    <div v-if="append" class="append-stripe-order">
      <div class="border-line color-white">
       
      </div>

      <div class="dot"></div>
      <div class="dot right"></div>
      <h5 class="append-stripe color-white">
        {{ $t("card.append") }}
      </h5>
      <span class="order text-center d-block color-white pb-0">{{
        appendMinutes
          ? $t("card.append_accepted_at", {
              time: formatDuration(appendMinutes),
            })
          : $t("card.append_accepted_now")
      }}</span>
      <!-- <span class="order text-center d-block color-white"></span> -->
    </div>

    <div
      :class="[
        order.status == 'waiting' ? 'info' : 'info white',
        order.client_name ? 'no-space' : 'info pb-0',
      ]"
      v-if="!append"
    >
      <img class="img-status" :src="statusIcon" />
      <div class="check-info">
        <h4 class="check-info-title">
          {{ isHotel ? $t("status.room") : $t("status.table_no") }}
          {{ orderTableDisplayName }}
        </h4>
        <h5 class="mb-0">
          {{ isHotel ? "" : $t("status.hall") + ":" }}
          {{ sectionName }}
        </h5>
        <div class="cheque-id">
          <span v-if="order.local_id">
            id:
            <h3>{{ order.local_id }}</h3>
          </span>
        </div>
      </div>
      <!-- <h4>{{ $t('status.table_no') }} № {{ order.table }} {{ sectionName }}:</h4> -->
    </div>

    <ClientName
      class="inside-bg"
      v-if="order.client_name"
      :clientName="order.client_name"
      :systemColor="black"
    />

    <InsideStatusBar :order="order" :splitting="splitting" />
    <!-- <div class="info">
      <div class="timing">
        <span class="time">{{ orderDatetime }}</span>
        <span
          :class="{
          'time': true,
          'edit-status-text': order.status == 'editing'  
        }"
        >{{ statusDescription }}</span>
        <span
          :class="{'serv-time': true, 'red-countdown': countdownRed}"
          v-if="['waiting', 'serving'].includes(order.status)"
        >{{ servingTime }}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
import moment from "moment";
import ClientName from "@/components/ClientName.vue";
import SharedQueueService from "@/services/shared";
import InsideStatusBar from "@/components/statusbar/InsideStatusBar.vue";

export default {
  components: {
    InsideStatusBar,
    ClientName,
  },
  props: {
    order: Object,
    append: {
      type: Boolean,
      default: false,
    },
    splitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      servingTime: "",
      timerId: 0,
      countdownRed: false,

      //Should we show "To serve: <timer ticking down>"
      //or "Serving: <time elapsed>"
      toServeTextFlag: false,
      appendMinutes: 0,
      black: "inside",
    };
  },
  methods: {
    updateServingTime() {
      if (this.order.served_at) {
        const diff = moment(this.order.served_at).diff(moment(this.order.date));
        this.servingTime = moment.duration(diff).format();
        this.countdownRed = false;
        return;
      }

      if (this.order.waiting_time) {
        // order accept ---- now ---- max wait date
        // time ------------ flows in this way  -->
        const maxWaitDate = moment(this.order.processed_at).add(
          this.order.waiting_time,
          "minutes"
        );
        if (moment().isBefore(maxWaitDate)) {
          const diff = maxWaitDate.diff(moment());

          const waitDuration = moment.duration(diff);

          this.countdownRed = waitDuration.asSeconds() <= 5 * 60;

          this.servingTime = waitDuration.format();
          this.toServeTextFlag = true;
          return;
        }
      }

      const diff = moment().diff(moment(this.order.date));
      this.servingTime = moment.duration(diff).format();
      this.countdownRed = false;
      this.toServeTextFlag = false;

      if (this.append) {
        this.appendMinutes = moment().diff(
          moment(this.order.processed_at),
          "minutes"
        );
      }
    },
    formatDuration(mins) {
      if (mins == 0) {
        return `0 ${this.$t("waiting.time")}`;
      }

      let hours = Math.abs(Math.floor(mins / 60));
      let remainder = Math.abs(mins) % 60;

      let result = "";

      if (mins < 0) result = "-";

      if (hours > 0) {
        result += `${hours} ${this.$t("waiting.hours")} `;
      }

      if (remainder > 0) {
        result += `${remainder} ${this.$t("waiting.time")}`;
      }

      return result;
    },
  },
  mounted() {
    this.updateServingTime();
    this.timerId = setInterval(this.updateServingTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  computed: {
    orderDatetime() {
      return moment(this.order.date).format("HH:mm [/] DD.MM");
    },
    sectionName() {
      return this.cafe.sections[this.order.section].name || "N/A";
    },
    statusClass() {
      return [
        this.append ? "item-status-append" : "item-status",
        `status-${this.order.status}`,
      ];
    },
    statusIcon() {
      return "/icons/dish.svg";

      if (this.order.status === "waiting" || this.append) {
        return "/icons/dish.svg";
      }

      // if (this.order.status === 'serving') {
      //   return '/icons/status-processing.svg';
      // }

      return "/icons/status-done.svg";
    },
    statusDescription() {
      if (this.order.status == "serving" && this.order.served_at) {
        return this.$t(`card.descriptions.served`);
      }

      if (this.order.status == "serving" && this.toServeTextFlag) {
        return this.$t(`card.descriptions.serving_timer`);
      }
      return this.$t(`card.descriptions.${this.order.status}`);
    },
    cafe() {
      return this.$store.state.cafe;
    },
    shouldShowWaiter() {
      return this.order.status !== "waiting" && window.innerWidth >= 768;
    },
    orderTableDisplayName() {
      const section = this.cafe.sections[this.order.section];

      if (
        section &&
        section.tables_list &&
        section.tables_list[this.order.table - 1]
      ) {
        const table_item = section.tables_list[this.order.table - 1];

        if (table_item.name) return table_item.name;
      }

      return `№${this.order.table}`;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 350px) {
  h4 {
    font-size: 19px !important;
    width: 215px !important;
  }
}

@media screen and (min-width: 300px) {
  h4 {
    width: auto !important;
    margin: -5px 0;
  }
  /* .img-status {margin: 5px 10px -5px  !important;} */
}

.inside-bg {
  background: #aeccc6 !important;
}

.append-stripe-order {
  position: relative;
}

.no-space {
  padding: 0 20px;
}


.check-info {
  display: flex;
  flex-flow:column wrap;
  width: 60%;
}

.cheque-id span {
  display: flex;
  align-items: baseline;
  position: absolute;
  top: 3vh;
  right: 2.5vh;
}

.cheque-id h3 {
  margin: 0;
  line-height: 1;
  font-size: 3.7vh;
}
.hall {
  overflow: hidden;
  max-width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}

span.order {
  font-size: 2.3vh;
  padding-bottom: 2vh;
  text-align: center;
  display: block;
}

h5.append-stripe {
  line-height: 1.2;
  font-size: 1.8vh;
  text-align: center;
  margin: 0;
  padding-bottom: 1vh;
  display: block;
  margin-top: -4.5vh !important;
  letter-spacing: 0 !important;
}

.waiter-flag {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  background: white;
  max-width: 200px;
  box-shadow: 2px 3px 4px rgba(128, 128, 128, 0.25);
  color: black;
  font-weight: 400;
  font-size: 2.2222vh;
  padding: 0.001vh 1.111vh;
  border-radius: 1.111vh 1.111vh 0px 0;
  border: 0.111vh solid #bcbcbc;
  position: absolute;
  bottom: 100%;
  /* left: 9vh; */
  right: 2vh;
  float: right;
  text-align: center;
}

/* @media screen and (min-width: 1200px) {
  .info h4 {
    max-width: 100% !important;
  }
} */

@media (min-width: 300px) and (max-width: 768px) {
  .serv-time {
    text-align: right;
    margin-right: 0px !important;
  }
}
/* 
.client-name {
  width: 100%;
  position: relative;
  background: #aeccc6;
  font-size: 6.7vw;
  padding: 1.3vh 5.4vw;
  margin-top: -1vh;
} */

.client-name h4 {
  color: #1d1d1d;
}

.timing {
  line-height: 0.8;
  display: flex;
  padding-top: 0.5vh;
  justify-content: space-between;
}

.timing .time {
  width: 55vw;
}

h4.check-info-title {
  color: #ededed;
  overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
  max-width: 100%;
-webkit-box-orient: vertical;
  font-size: 2.3vh;
  line-height: 1;
  margin: 0px;
  font-weight: 400;
}

h4:nth-child(3) {
  padding-bottom: 0px;
  margin-bottom: -15px;
}

b {
  line-height: 0.8;
  font-weight: 500;
}

.item-status {
  border-radius: 2.5vh 2.5vh 0 0;
  min-width: 100%;
}

.dot {
  height: 20px;
  width: 20px;
  border-radius: 10px;
  margin-left: -1.5vh;
  top:-1.3vh;
  background: #ededed;
  position: absolute;
}

.dot.right {
  right: 0;
  margin: 0 -1.5vh 0 0;
}

.item-status-append {
  display: block;
  margin-top: 0;
  padding: 2.5vh 0 0;
  border-radius: 0;
  width: 100%;
}

.border-line {
  width: 100%;
  height: 1.5vh;
  font-weight: 100;
  font-size: 3.8vw;
  border-top: 1px dashed #ededed;
  margin-top: 1.1vh;
}

.status-waiting {
  background: #1d1d1d;
}

.status-serving {
  /* background: #416293; */
  background: #1d1d1d;
}

.status-editing {
  /* background: #416293; */
  background: #1d1d1b;
}

.status-served {
  background: #129b81;
}

.status-paying {
  background: #1d1d1d;
}

.status-executed {
  /* background: #129b81; */
  background: #1d1d1b;
}

.edit-status-text {
  color: #ffd2a8;
}

img.img-status {
  height: 4.7vh;
  width: auto;
  top: 0;
  position: relative;
  margin-right: 3.5vw;
}

.info {
  position: relative;
  padding: 20px 20px 15px;
  display: flex;
  width: 100%;
  color: #ededed;
}

.info.white {
  color: #ededed;
}

.info h5 {
  display: inline-block;
  font-size: 2.2vh;
  color: #908f8d;
  line-height: 0.8;
}

@media screen and (min-width: 768px) {
  .dot.right {
     /* margin: -3vh -1.5vh 0 0; */
  }
  div.item-status.status-paying {
    border-radius: 1.2vw 1.2vw 0 0;
  }
  div.info.white {
    padding: 1.389vw;
    border-radius: 1.389vw 1.389vw 0 0;
  }
  img.img-status {
    width: 2.569vw;
    height: 2.569vw;
    margin-right: 0.694vw;
  }
  
  h5.mb-0 {
    font-size: 0.903vw;
    line-height: 1.042vw;
  }
  .cheque-id span {
    font-size: 1.042vw;
    line-height: 1.181vw;
  }
  .cheque-id span h3 {
    font-size: 1.5vw;
    line-height: 2.431vw;
  }
  /* .client-name {
    padding: 1.389vw 0.556vw;
    font-size: 1.736vw;
  } */
  .item-status {
    border-radius: 2.3vh;
  }
  h5.append-stripe {
    line-height: 1.5;
    text-align: center;
    margin: 0;
    display: block;
    margin-top: -5vh !important;
    letter-spacing: 0 !important;
    font-size: 2vh;
  }
}

.red-countdown {
  color: rgb(247, 48, 48);
  /* animation: blinker 1.5s linear infinite; */
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
